<script setup lang="ts">
// Vue & Plugins
import { computed, watch } from "vue"

// Data
const {
  buttonState = 'normal',
  label = undefined,
  icon = undefined,
  successLabel = undefined,
  errorLabel = undefined,
} = defineProps<{
  buttonState?: "normal" | "success" | "error"
  label?: string
  icon?: string
  successLabel?: string
  errorLabel?: string
}>()

const emit = defineEmits<{
  "update:buttonState": [value: "normal" | "success" | "error"]
}>()

const reset = () => {
  setTimeout(() => {
    emit("update:buttonState", "normal")
  }, 2000)
}

watch(
  () => buttonState,
  (newState) => {
    if (newState === "success" || newState === "error") {
      reset()
    }
  }
)

const severity = computed(() => {
  switch (buttonState) {
    case "success":
      return "success"
    case "error":
      return "error"
    default:
      return "info"
  }
})

const buttonLabel = computed(() => {
  switch (buttonState) {
    case "success":
      return successLabel ?? label
    case "error":
      return errorLabel ?? label
    default:
      return label
  }
})

const buttonIcon = computed(() => {
  if (icon === undefined || icon === null) {
    return undefined
  }

  switch (buttonState) {
    case "success":
      return "pi pi-check"
    case "error":
      return "pi pi-times"
    default:
      return icon
  }
})
</script>

<template>
  <Button :severity="severity" :label="buttonLabel" :icon="buttonIcon" />
</template>
